import React from 'react'
import styled from 'styled-components'
import { Media } from '../../theme'
import Link from '../link'
import MIFA from './MIFA.png'
import { ReactComponent as CloseIcon } from './close.svg'
import ArrowRight from '@raysync/common/components/svg/smb/arrow-3'
const Tip = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(270deg, #fd5c1f 0%, #fd8e1f 50%, #fd5c1f 100%);
  text-align: left;
  position: fixed;
  top: 0;
  z-index: 4800;
  cursor: pointer;
  div {
    margin-left: 40px;
  }
  p {
    font-size: 30px;
  }
  span {
    font-size: 16px;
  }
  .topnotice-arrow {
    margin-left: 10px;
    transition: transform 0.3s ease-in-out;
  }
  :hover {
    .topnotice-arrow {
      transform: translateX(10px);
    }
  }
  .topnotice-arrow-right {
    position: absolute;
    right: 60px;
  }
  ${Media.phone`
      font-size: 12px;
      height: 60px;
      span {
        width: 6.7rem;
      }
    `}
`

const Container = styled(Link)`
  height: 80px;
  width: 100%;
  padding: 0 60px;
  position: sticky;
  top: 0;
  z-index: 4800;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url(${MIFA}) no-repeat center;
  background-position: center;
  background-size: cover;
  cursor: pointer;
  p {
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      height: 18px;
      margin-left: 10px;
    }
  }
  ${Media.phone`
   height: .96rem;
   background-size: 100% 100%;
   p {
    font-size: .28rem;
   }
    span {
      display: none;
    }
  `}
`
const isInMain = process.env.GATSBY_PACKAGE_NAME === 'main'
const TopNotice = ({ onClose }) => {
  return (
    <Container
      to='/apply/exhibition'
      isInternal={isInMain}
      onClick={() => {
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem('topNoticeClosed', 'true')
        }
      }}
    >
      <p>
        Meet us at IBC 2025! Amsterdam | September 12-15 | Booth 14.C49
        <ArrowRight />
      </p>
      <span
        onClick={e => {
          e.stopPropagation()
          e.preventDefault()
          onClose()
        }}
      >
        <CloseIcon />
      </span>
    </Container>
  )
}

export default TopNotice
